// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"TooltipComponent_Tooltip__5h45z"};